"use strict";

import React, { useState, useEffect } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";
import { hexToColorName } from "../../utils/colorNameUtil";

const ColorPicker = ({ value, onChange, presetColors, Dyn, onClose }) => {
    const [color, setColor] = useState(value);
    useEffect(() => {
        onChange(color);
    }, [color]);
    return (
        <>
            <div className="tde-picker-btns">
                {presetColors.map((presetColor, index) => {
                    const colorName = hexToColorName(presetColor);
                    return (
                        <button
                            key={presetColor}
                            className="tde-picker-btn"
                            data-index={index}
                            autoFocus={index === 0}
                            style={{ background: presetColor }}
                            onClick={() => {
                                setColor(presetColor);
                                // Close picker after selecting preset color
                                // Use a delay to ensure color change is processed
                                if (onClose) {
                                    setTimeout(() => {
                                        onClose();
                                    }, 350);
                                }
                            }}
                            aria-label={`${colorName}, ${presetColor}`}
                        />
                    );
                })}
            </div>
            <HexColorPicker color={color} onChange={setColor} />
            <div className="tde-d-flex tde-picker-input">
                <div>#</div>
                <div className="tde-flex-1">
                <HexColorInput
                    className="tde-input tde-input-text tde-fill"
                    style={{ borderLeft: 0}}
                    color={color}
                    onChange={setColor}
                    aria-label={Dyn ? Dyn.loc("Hex color code") : "Hex color code"}
                />
                </div>
            </div>
        </>
    );
};

class ColorPickerComponent extends React.Component {
    handleChange = (color) => {
        // Trigger change color after timeout.
        if (this.changeTimeout) {
            clearTimeout(this.changeTimeout);
        }
        this.changeTimeout = setTimeout(() => {
            this.props.handleChange({ hex: color }, this.props.name);
        }, 300);
    };

    render = () => {
        const presetColors = this.props.presetColors || [
            "#767676",
            "#486FFB",
            "#DE51AB",
            "#7CBF31",
            "#B39329",
            "#A42124",
        ];

        return (
            <div
                className="tde-color-picker tde-font-source-sans-pro"
                style={this.props.style}
                role="dialog"
                aria-modal="true"
                aria-labelledby="tde-color-picker-title"
            >
                <h3
                    id="tde-color-picker-title"
                    className="tde-mb-1 tde-mt-0"
                    style={{fontSize: 18}}
                >
                    {this.props.Dyn.loc("Color Picker")}
                </h3>
                <ColorPicker
                    value={this.props.color}
                    onChange={this.handleChange}
                    presetColors={presetColors}
                    Dyn={this.props.Dyn}
                    onClose={this.props.onClose}
                />
            </div>
        );
    };
}

export default ColorPickerComponent;
